/* bs-product-faq — acordeón de "Preguntas frecuentes" de la PDP. Cada ítem se abre/cierra de
   forma INDEPENDIENTE (a diferencia de bs-product-datasheet.js, que fuerza "solo uno abierto
   a la vez") — no hay lógica de "cerrar los demás" al abrir uno nuevo.

   El primer ítem viene ABIERTO server-rendered (bs-product-faq__item--open, aria-expanded
   "true", panel sin inert). Este script respeta ese estado inicial: NO fuerza el cierre de
   nada al inicializar, solo ata los listeners de click.

   Mismo patrón de animación por height que bs-product-datasheet.js/bs-faq-help.js
   (scrollHeight + doble rAF + transitionend), respeta prefers-reduced-motion. */

(function () {
  'use strict';

  var OPEN_CLASS = 'bs-product-faq__item--open';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animateOpen(item, trigger, panel) {
    panel.dataset.animating = 'true';
    item.classList.add(OPEN_CLASS);
    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('inert'); // a11y: panel abierto vuelve al árbol de foco/AT

    if (reduceMotion) {
      panel.style.height = '';
      panel.dataset.animating = '';
      return;
    }

    var target = panel.scrollHeight;
    panel.style.height = '0px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.style.height = target + 'px';
      });
    });

    function onEnd(e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      panel.style.height = '';
      panel.dataset.animating = '';
    }
    panel.addEventListener('transitionend', onEnd);
  }

  function animateClose(item, trigger, panel) {
    panel.dataset.animating = 'true';
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('inert', ''); // a11y: panel cerrado fuera del árbol de foco/AT (inmediato)

    if (reduceMotion) {
      item.classList.remove(OPEN_CLASS);
      panel.style.height = '';
      panel.dataset.animating = '';
      return;
    }

    var start = panel.scrollHeight;
    panel.style.height = start + 'px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
    });

    function onEnd(e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      item.classList.remove(OPEN_CLASS);
      panel.style.height = '';
      panel.dataset.animating = '';
    }
    panel.addEventListener('transitionend', onEnd);
  }

  function initSection(section) {
    if (section.dataset.bsProductFaqInit) return;
    section.dataset.bsProductFaqInit = 'true';

    var list = section.querySelector('.bs-product-faq__list');
    if (!list) return;

    list.addEventListener('click', function (event) {
      var trigger = event.target.closest('.bs-product-faq__trigger');
      if (!trigger || !list.contains(trigger)) return;

      var item = trigger.closest('.bs-product-faq__item');
      var panel = item && item.querySelector('.bs-product-faq__panel');
      if (!item || !panel || panel.dataset.animating === 'true') return;

      var isOpen = item.classList.contains(OPEN_CLASS);

      /* Toggle independiente: NO se cierran otros ítems (a diferencia de datasheet). */
      if (isOpen) {
        animateClose(item, trigger, panel);
      } else {
        animateOpen(item, trigger, panel);
      }
    });
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('.bs-product-faq');
    sections.forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('load', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bs-product-faq');
    if (section) init(event.target);
  });
})();
